import React, { PropsWithChildren } from "react";

import Card, { CardProps } from "../Card/Card";
import ArrowRight from "@src/assets/svg/ArrowRight";
import { toClassName } from "@src/multiCustodian/utils/to-class-name";

import styles from "./CardButton.module.css";

type OnClick<T = undefined> = (
  e: React.MouseEvent<HTMLButtonElement>,
  data?: T
) => void;

interface CardButtonProps<T = undefined> extends CardProps {
  hover?: boolean;
  isSelected?: boolean;
  onClick?: OnClick<T>;
}

const CardButton = <T,>({
  className,
  isSelected,
  onClick,
  header,
  children,
  hover = true,
}: PropsWithChildren<CardButtonProps<T>>) => {
  const handleOnClick: React.MouseEventHandler<HTMLButtonElement> = (e) => {
    if (onClick) {
      onClick(e);
    }
  };

  const enableHover = isSelected ? false : hover;

  const isClickable = onClick !== undefined;

  const headerIsString = typeof header === "string";

  const baseButtonClasses = toClassName(styles.button, className, {
    [styles.disableHover]: !enableHover || !isClickable,
  });

  return (
    <button
      className={baseButtonClasses}
      disabled={!isClickable}
      onClick={handleOnClick}
    >
      <Card
        className={styles.card}
        headerIcon={
          headerIsString ? <ArrowRight className={styles.icon} /> : undefined
        }
        header={header}
      >
        {children}
      </Card>
    </button>
  );
};

export default CardButton;
